export default class BaseCounter {
    
    /**
     * @var { boolean }
     */
    visible = false

    /**
     * @var { string }
     */
    startTime = null

    /**
     * @var { object }
     */
    separators = {
        none: '',
        comma: ',',
        period: '.',
        space: ' ',
    }

    /**
     * startCount
     * Description: Starts the counting animation.
     * @param { string } thousands 
     * @param { string } decimal 
     * @returns { void }
     */
    startCount(thousands = 'comma', decimal = 'period'){

        const step = (currentTime) => {

            if (!this.startTime) {
                this.startTime = currentTime ;
            }

            const progress = Math.min((currentTime  - this.startTime) / 1500, 1);

            let number = parseFloat(this.$refs.number.dataset.counterNumber);
            const hasDecimal = (number - Math.floor(number)) !== 0;
            let countedNumber;

            if (hasDecimal) {
                countedNumber = this.separateDecimals((progress * number).toFixed(1), decimal);
            } else {
                countedNumber = Math.floor(progress * number);
            }

            this.$refs.number.innerHTML = this.separateThousands(countedNumber, thousands);

            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
            else{
                window.cancelAnimationFrame(window.requestAnimationFrame(step));
            }
        };

        window.requestAnimationFrame(step);

    }

    /**
     * separateDecimals
     * Description: Separates the decimals of a number with the specified separator
     * @param { int } number 
     * @param { string } separator 
     * @returns { string } transformed number with the specified separator
     */
    separateDecimals(number, separator = 'period') {
        return number.toString().replace('.', this.separators[separator]);
    }

    /**
     * separateThousands
     * Description: Separates the thousands of a number with the specified separator
     * @param { int } number 
     * @param { string } separator 
     * @returns { string } transformed number with the specified separator
     */
    separateThousands(number, separator = 'comma') {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, this.separators[separator]);
    }

}

document.addEventListener('alpine:init', () => {
    Alpine.data('counter', () => new BaseCounter());
});
